import React, { useContext, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import {
 AppRoutes,
 GramUnits,
 IEUnits,
 MolUnits,
 UnitType,
} from '../../../../types';

import CalculatorComponent from '../../../../components/CalculatorComponent';

import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { CalculatorContext } from '../../../../contexts/CalculatorProvider';
import { LiquidContext } from '../../../../contexts/LiquidProvider';

function LiquidDraperResultScreen(): React.ReactElement {
 const {
  setBackButtonText,
  setNextButtonText,
  setNextButtonAction,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const {
  secondScreenRedirect,
  thirdScreenRedirect,
  onSelectChange,
  onValueChange,
  getValueInitialState,
  getSelectInitialState,
  setSelectedUnit,
  setCurrentScreen,
 } = useContext(LiquidContext);

 const {
  setHasCheckbox,
  setPageTitle,
  setQuestion,
  setCheckboxText,
  setUnitTypes,
  setCheckboxAction,
  checkboxValue,
 } = useContext(CalculatorContext);

 const unitTypes = [
  ...GramUnits.filter(
   unit =>
    ![UnitType.Kilogram, UnitType.KilogramPerMl].includes(unit.description),
  ),
  ...MolUnits,
  ...IEUnits,
 ];

 const navigate = useNavigate();

 const homeRedirect = () => () => {
  setCurrentScreen(-1);
  navigate(AppRoutes.Liquid);
 };

 const setNavigationProps = () => {
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(homeRedirect);
  };
  const setNextButtonProps = () => {
   setNextButtonText('Neste');
   setNextButtonAction(thirdScreenRedirect);
  };
  setBackButtonProps();
  setNextButtonProps();
 };

 const setCalculatorProps = () => {
  setHasCheckbox(true);
  setPageTitle('Flytende - Dråper');
  setQuestion('Hva er den ordinerte dosen?');
  setCheckboxText('pr kg av pasientens kroppsvekt');
  setUnitTypes(unitTypes);
 };

 useEffect(() => {
  setNavigationProps();
  setCalculatorProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 useEffect(() => {
  if (checkboxValue) {
   setCheckboxAction(() => setNextButtonAction(secondScreenRedirect));
  } else {
   setCheckboxAction(() => setNextButtonAction(thirdScreenRedirect));
  }
 }, [
  checkboxValue,
  secondScreenRedirect,
  setCheckboxAction,
  setNextButtonAction,
  thirdScreenRedirect,
 ]);

 return (
  <CalculatorComponent
   onValueChange={onValueChange}
   onSelectChange={value => {
    onSelectChange(value);
    setSelectedUnit(value);
   }}
   valueInitialState={getValueInitialState()}
   selectInitialState={getSelectInitialState()}
  />
 );
}

export default LiquidDraperResultScreen;
